// 图文
import {post, postJson} from './http'
const baseUrl = '/api/admin/kmc/article'
const commodity = '/api/admin/gooddivision'
const sxy = '/api/admin/kmc/sxytopic'

// 图文列表
export const articleList = v => post(`${baseUrl}/findAllArticle`, v.data, v.success, v.error)
// 新建图文信息
export const newArticleMsg = v => post(`${baseUrl}/saveArticle`, v.data, v.success, v.error)
// 修改图文信息
export const editArticleMsg = v => post(`${baseUrl}/updateArticle`, v.data, v.success, v.error)
// 图文上架或图文下架或图文删除
export const articleAction = v => post(`${baseUrl}/updataArticlebyInnerid`, v.data, v.success, v.error)
// 单个图文详情
export const getArticleInfo = v => post(`${baseUrl}/getArticleInfo`, v.data, v.success, v.error)
// 商品分组
export const commodityGroup = v => post(`${commodity}/findAllGooddivisionName`, v.data, v.success, v.error)
// 商品分组详情
export const commodityGroupMsg = v => post(`${commodity}/getGooddivisiondetail`, v.data, v.success, v.error)
// 加入推荐 或 取消推荐
export const joinRecommend = v => post(`${baseUrl}/updataArticleRecomm`, v.data, v.success, v.error)  

// 投稿列表
export const findAllByContribution = v => post(`${baseUrl}/findAllByContribution`, v.data, v.success, v.error)  

// 投稿删除
export const deleteArticlebyInnerid = v => post(`${baseUrl}/deleteArticlebyInnerid`, v.data, v.success, v.error)  

// 单个图文详情（专栏投稿）
export const getArticleInfoByCon = v => post(`${baseUrl}/getArticleInfoByCon`, v.data, v.success, v.error)  

// 新建图文信息(专栏投稿
export const saveOrUpdateArticle = v => post(`${baseUrl}/saveOrUpdateArticle`, v.data, v.success, v.error)
// 获取专题列表
export const getAllTopicinfo = v => post(`${sxy}/getAllTopicinfo`, v.data, v.success, v.error)
// 获取分类列表
export const getAllTopiccolumninfo = v => post(`${sxy}/getAllTopiccolumninfo`, v.data, v.success, v.error)
// 保存分类
export const uploadSxytopiccolumninfo = v => postJson(`${sxy}/uploadSxytopiccolumninfo`, v.data, v.success, v.error)
// 删除分类
export const deleteSxytopiccolumninfo = v => postJson(`${sxy}/deleteSxytopiccolumninfo`, v.data, v.success, v.error)
// 分类排序
export const uploadSxytopiccolumnindex = v => postJson(`${sxy}/uploadSxytopiccolumnindex`, v.data, v.success, v.error)
// 分类列表 不分页
export const getSxytopiccolumninfo = v => postJson(`${sxy}/getSxytopiccolumninfo`, v.data, v.success, v.error)
// 获取广告配置
export const getSxyTopicinfo = v => postJson(`${sxy}/getSxyTopicinfo`, v.data, v.success, v.error)
// 保存广告配置
export const uploadSxyTopicinfo = v => postJson(`${sxy}/uploadSxyTopicinfo`, v.data, v.success, v.error)
// 保存广告配置
export const getAllSxytopiccontentinfo = v => postJson(`${sxy}/getAllSxytopiccontentinfo`, v.data, v.success, v.error)
// 保存资讯
export const uploadSxytopiccontentinfo = v => postJson(`${sxy}/uploadSxytopiccontentinfo`, v.data, v.success, v.error)
// 获取资讯详情
export const getSxytopiccontentinfo = v => postJson(`${sxy}/getSxytopiccontentinfo`, v.data, v.success, v.error)
// 删除资讯
export const uploadQuestionbanktopiccontentStatus = v => postJson(`${sxy}/uploadQuestionbanktopiccontentStatus`, v.data, v.success, v.error)
// 信息收集
export const getCommonUserFormList = v => postJson(`${sxy}/getCommonUserFormList`, v.data, v.success, v.error)
// 报名信息
export const getRelbmCommonFormList = v => postJson(`${sxy}/getRelbmCommonFormList`, v.data, v.success, v.error)
// 改变资讯推荐状态
export const uploadSxytopiccontentIstop = v => postJson(`${sxy}/uploadSxytopiccontentIstop`, v.data, v.success, v.error)